import {
    createTheme,
    genPageTheme,
    lightTheme,
    shapes,
  } from '@backstage/theme';

export const marsMainTheme = createTheme({
    palette: {
      ...lightTheme.palette,
      primary: {
        main: '#343b58',
      },
      secondary: {
        main: '#565a6e',
      },
      error: {
        main: '#343b58',
      },
      warning: {
        main: '#8f5e15',
      },
      info: {
        main: '#34548a',
      },
      success: {
        main: '#485e30',
      },
      background: {
        default: '#d5d6db',
        paper: '#d5d6db',
      },
      banner: {
        info: '#34548a',
        error: '#343b58',
        text: '#343b58',
        link: '#565a6e',
      },
      errorBackground: '#343b58',
      warningBackground: '#8f5e15',
      infoBackground: '#343b58',
      navigation: {
        background: '#343b58',
        indicator: '#8f5e15',
        color: '#d5d6db',
        selectedColor: '#ffffff',
      },
    },
    defaultPageTheme: 'home',
    pageTheme: {
      home: genPageTheme({ colors: ['#343b58', '#343b58'], shape: shapes.wave }),
      documentation: genPageTheme({
        colors: ['#343b58', '#343b58'],
        shape: shapes.wave2,
      }),
      tool: genPageTheme({ colors: ['#343b58', '#343b58'], shape: shapes.round }),
      service: genPageTheme({
        colors: ['#343b58', '#343b58'],
        shape: shapes.wave,
      }),
      website: genPageTheme({
        colors: ['#343b58', '#343b58'],
        shape: shapes.wave,
      }),
      library: genPageTheme({
        colors: ['#343b58', '#343b58'],
        shape: shapes.wave,
      }),
      other: genPageTheme({ colors: ['#343b58', '#343b58'], shape: shapes.wave }),
      app: genPageTheme({ colors: ['#343b58', '#343b58'], shape: shapes.wave }),
      apis: genPageTheme({ colors: ['#343b58', '#343b58'], shape: shapes.wave }),
    },
  });
  